import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/Categories'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class CategoriesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "CategoriesStore",
			variables: true,
		})
	}
}

export async function load_Categories(params) {
  await initClient()

	const store = new CategoriesStore()

	await store.fetch(params)

	return {
		Categories: store,
	}
}
